import { render, staticRenderFns } from "./OwnersCrud.vue?vue&type=template&id=70f08366"
import script from "./OwnersCrud.vue?vue&type=script&lang=js"
export * from "./OwnersCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports